import { format } from 'date-fns';

export const formatTime = (date: Date) => format(date, 'h:mmaaa');

export const formatDate = (date: Date) => format(date, 'EEEE, MMMM d, yyyy');

export const formatShortDate = (date: Date) => format(date, 'EEEE, MMMM d');
